import React, { FC, memo } from 'react';
import { useTranslation } from 'react-i18next';
import { isMassCreativeCreateMessage } from 'domains/notification/types';
import css from '../styles.module.scss';
import { TBatchdownloadType } from '../types';

const BatchDownloadNotification: FC<{
  notification: TBatchdownloadType;
  handleMarkAsRead: () => void;
  handleGetTask: (task_id: number) => void;
}> = ({ notification, handleMarkAsRead, handleGetTask }) => {
  const { t } = useTranslation();
  const { text, message } = notification;

  return (
    <div className={css.item__content}>
      <div className={css.item__text}>{text}</div>
      <div className={css.item__actions}>
        <button
          type="button"
          className={css.item__link}
          onClick={() => {
            handleMarkAsRead();
            if (isMassCreativeCreateMessage(message)) {
              handleGetTask(message.task_id);
            }
          }}
        >
          {t(`watch_btn`)}
        </button>
      </div>
    </div>
  );
};

export default memo(BatchDownloadNotification);
